
const variants = [1, 2];

export default {
  name: 'EditoHeader',
  props: {
    /**
     * Left doodle
     */
    leftDoodle: {
      type: String,
      default: undefined,
    },
    /**
     * Right doodle
     */
    rightDoodle: {
      type: String,
      default: undefined,
    },
    /**
     * Header subhead
     */
    subhead: {
      type: String,
      default: undefined,
    },
    /**
     * Header text
     */
    text: {
      type: String,
      default: undefined,
    },
    /**
     * Header title
     * @see elements/doodle-text
     */
    title: {
      type: Object,
      required: true,
    },
    /**
     * Doodle position variants
     */
    variant: {
      type: Number,
      default: variants[0],
      validator: (variant) => variants.includes(variant),
    },
  },
  computed: {
    cssClass() {
      return `-variant-${this.variant}`;
    },
  },
};
